export default "__VITE_ASSET__BTgB4cTv__"